import {useEffect, useState} from "react"

const getSize = (width, height) => {
    return window.innerWidth < width || window.innerHeight < height
}

export const useIsMobile = (width, height) => {
    const [state, setState] = useState(getSize(width, height));

    const isMobil = () => {
        return state
    }

    useEffect(() => {
        const onResize = () => {
            setState(getSize(width, height))
        }

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);


    return {isMobil};
}
